import genericClient from './genericClient';
export { genericClient };